import { createFileRoute } from '@tanstack/react-router';

import { SetupPage } from 'src/apps/enterprise/app/pages/Setup';

export const Route = createFileRoute('/_auth/enterprise/enroll/setup')({
  component: () => <SetupPage />,
});
